import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { Button, Grid, TextField } from '@mui/material'
import validator from 'validator'
import { Box } from '@mui/system'
import logo1 from '../assets/img/logo.jpg'
import logo2 from '../assets/img/white-logo.png'
import axios from '../api/axios'

const Login = () => {
   // const [account, setAccount] = useState(null)
   const navigate = useNavigate()
   const [mobileView, setMobileView] = useState(false)
   const [mail, setMail] = useState('')
   const [pass, setPass] = useState('')

   const SignIn = async () => {
      if (mail && validator.isEmail(mail)) {
         if (pass !== '') {
            let data = {
               mail,
               pass,
            }
            try {
               await axios
                  .post('signin', { data })
                  .then((result) => {
                     if (result.data.login) {
                        const Data = result.data.data
                        delete Data.__v
                        delete Data.password

                        localStorage.setItem(
                           'accessToken',
                           JSON.stringify(Data.accessToken)
                        )
                        toast.success('Login Successed')
                        delete Data.accessToken
                        localStorage.setItem('user', JSON.stringify(Data))
                        if (Data.permission === 'user' || Data.permission === 'retailer') {
                           window.location.replace(`${window.origin}/dashboard`)
                        }
                        if (Data.permission === 'admin') {
                           window.location.replace(
                              `${window.origin}/admin_dashboard`
                           )
                        }
                        // navigate('admin_dashboard')
                     } else {
                        toast.error(result.data.data)
                     }
                  })
            } catch (error) {
               if (process.env.REACT_APP_MODE) console.log(error)
               toast.error('Ett fel uppstod. Försök igen.')
            }
         } else {
            toast.error('Please input password!')
         }
      } else {
         toast.error('Email is not valid')
      }
   }

   const getWidth = () =>
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth

   useEffect(() => {
      const setResponsiveness = () => {
         getWidth() < 900 ? setMobileView(true) : setMobileView(false)
      }
      window.addEventListener('resize', setResponsiveness)
      return () => {
         window.removeEventListener('resize', setResponsiveness)
      }
   }, [])

   //useEffect(() => {
   //   let user = localStorage.getItem('user')
   //   if (user) {
   //      let parse = JSON.parse(user)
   //      setAccount(parse)
   //   }
   //}, [])

   return (
      <Grid className="right-bg" item xs={12} md={6} lg={6}>
         <Box
            sx={{
               flexGrow: 1,
               justifyContent: 'center',
               alignItems: 'center',
               display: 'flex',
               flexDirection: 'column',
               gap: '20px',
            }}
            className="login-form"
         >
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
               <img
                  alt="logo"
                  src={mobileView ? logo2 : logo1}
                  style={{ width: '100%' }}
               />
            </Box>
            <Box
               component="form"
               onSubmit={(e) => { e.preventDefault(); SignIn(); }}
               sx={{ display: 'contents' }}
            >
               <Box>
                  <TextField
                     variant="filled"
                     type="email"
                     fullWidth
                     label="Email*"
                     value={mail}
                     onChange={(e) => {
                        setMail(e.target.value)
                     }}
                  />
               </Box>
               <Box>
                  <TextField
                     variant="filled"
                     type="password"
                     label="Password*"
                     fullWidth
                     value={pass}
                     onChange={(e) => {
                        setPass(e.target.value)
                     }}
                  />
               </Box>
               <Box>
                  <Button
                     type="submit"
                     variant="contained"
                     size="small"
                     fullWidth
                  >
                     Sign In
                  </Button>
               </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
               <p
                  onClick={() => {
                     navigate('forgot-password')
                  }}
                  style={{
                     cursor: 'pointer',
                     textDecoration: 'underline',
                     color: 'blue',
                  }}
               >
                  Forgot password?
               </p>
            </Box>
            <Box
               sx={{
                  display: 'flex',
               }}
            >
               Don't have an account yet?&nbsp;&nbsp;
               <span
                  onClick={() => {
                     navigate('/register')
                  }}
                  style={{
                     textAlign: 'right',
                     cursor: 'pointer',
                     textDecoration: 'underline',
                     color: 'blue',
                  }}
               >
                  Sign Up
               </span>
            </Box>
         </Box>
      </Grid>
   )
}
export default Login
